module.exports = __webpack_public_path__ + "static/media/18.b7615d20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/18.jpg
// module id = 86
// module chunks = 0